import Process from "./process";
import Planning from "../../../assets/planning.webp";
import Design from "../../../assets/design.webp";
import Development from "../../../assets/development.webp";
import Quality from "../../../assets/quality.webp";
import Deploy from "../../../assets/deploy.webp";
import Maintenance from "../../../assets/maintenance.webp";

const Processes = () => {
  return (
    <div className="processes-container">
      <div className="processes-details">
        <div className="dash"></div>
        <h3>Our Software Development Process</h3>
        <p>
          At Amorserv Solutions, our expert agile development team follows a
          comprehensive software development process to ensure that we deliver
          high-quality software solutions to our clients. Our software
          development process consists of the following steps:
        </p>
      </div>
      <div className="processes">
        <Process
          img={Planning}
          title={"Planning and Research"}
          desc={"We work closely with you to understand your business needs and requirements. We conduct extensive research to identify the best technologies and methodologies to use for each project."}
        />

        <Process
          img={Design}
          title={"Design and Prototyping"}
          desc={"We create a detailed design and prototype of your software solution, which includes the user interface, user experience, user interactions, and functionality."}
        />

        <Process
          img={Development}
          title={"Development"}
          desc={"We use the latest technologies and methodologies to develop your software solution. Our developers work in an agile manner to ensure that the software is developed efficiently and effectively."}
        />

        <Process
          img={Quality}
          title={"Quality Assurance"}
          desc={"We conduct rigorous testing to ensure that your software solution is free of bugs and errors. We use automated testing tools and manual testing methods to ensure that the software meets the highest quality standards."}
        />

        <Process
          img={Deploy}
          title={"Deployment"}
          desc={"We deploy your solution to your production environment using automated deployment and DevOps tools, ensuring seamless transition between development and implementation."}
        />

        <Process
          img={Maintenance}
          title={"Maintenance"}
          desc={"We provide ongoing maintenance and support as well as assisting your team with management of your database infrastructure and back-end applications to ensure that your software solution continues to meet your business needs."}
        />
      </div>
    </div>
  );
};

export default Processes;
